import { useTranslation } from 'react-i18next';
import { Form } from '@fuxi/eevee-ui';
import DiscoveryItems from './DiscoveryItems';

const QndAFormItems = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('consultForm.knownFrom.question')}
      name="discover"
      required
      validateFirst
      rules={[
        {
          required: true,
          message: '请选择您从哪里了解到瑶台的',
        },
        {
          validator: (_, data) => {
            const list = Object.keys(data).filter(key => typeof data[key] === 'boolean');

            const res = data.values.length > 0 ? true : list.some(key => data[key]);

            if (data?.hasYtActivity && data?.ytActivity?.length > 60) {
              return Promise.reject(t('consultForm.knownFrom.validYtLength'));
            }
            if (data?.hasSpeech && data?.speech?.length > 60) {
              return Promise.reject(t('consultForm.knownFrom.validSpeechLen'));
            }
            if (data?.hasOther && data?.other?.length > 60) {
              return Promise.reject(t('consultForm.knownFrom.validOtherLen'));
            }
            return res ? Promise.resolve() : Promise.reject('请选择您从哪里了解到瑶台的');
          },
        },
      ]}>
      <DiscoveryItems />
    </Form.Item>
  );
};

export default QndAFormItems;
